// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2uOQdQpcLGqV50 {\n  height: 16px;\n  width: 16px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "_2uOQdQpcLGqV50"
};
export default ___CSS_LOADER_EXPORT___;
